
import { useSelector  } from 'react-redux';

import { getDataProjectId } from '../reducers/project';

export default function useDataProjectId() {
    const projectId = useSelector(state => getDataProjectId(state.project));
    return projectId;
}
